import { dryingWhitelists } from 'Utils/rocketDryMaterialWhitelist';

export const numberInputRegex = /[^\-.0-9]/g;

export function checkValidRelativeHumidity(value: number): boolean {
  return value >= 0 && value <= 100;
}

export function checkValidTemperature(value: number): boolean {
  return value >= -999 && value <= 999;
}

export function checkValidDewPoint(value: number): boolean {
  return value >= -999 && value <= 999;
}

export function checkValidGPP(value: number): boolean {
  return value >= 0 && value <= 999;
}

const gppTable = {
  100: '302.3',
  99: '292.7',
  98: '283.4',
  97: '274.4',
  96: '265.6',
  95: '257.1',
  94: '248.9',
  93: '240.9',
  92: '233.1',
  91: '225.6',
  90: '218.3',
  89: '211.2',
  88: '204.3',
  87: '197.7',
  86: '191.2',
  85: '184.9',
  84: '178.8',
  83: '173',
  82: '167.2',
  81: '161.7',
  80: '156.3',
  79: '151.1',
  78: '146',
  77: '141.1',
  76: '136.4',
  75: '131.7',
  74: '127.3',
  73: '123',
  72: '118.8',
  71: '114.7',
  70: '110.7',
  69: '107',
  68: '103.2',
  67: '99.7',
  66: '96.2',
  65: '92.8',
  64: '89.6',
  63: '86.5',
  62: '83.4',
  61: '80.4',
  60: '77.6',
  59: '74.8',
  58: '72.1',
  57: '69.5',
  56: '67',
  55: '64',
  54: '62.3',
  53: '60',
  52: '57.8',
  51: '55.7',
  50: '53.6',
  49: '51.6',
  48: '49.7',
  47: '47.8',
  46: '46.1',
  45: '44.3',
  44: '42.6',
  43: '41',
  42: '39.5',
  41: '38',
  40: '36.5',
  39: '35.1',
  38: '33.7',
  37: '32.4',
  36: '31.2',
  35: '29.9',
  34: '28.8',
  33: '27.6',
  32: '26.5',
  31: '25.3',
  30: '24.2',
  29: '23.1',
  28: '22',
  27: '21',
  26: '20.1',
  25: '19.1',
  24: '18.2',
  23: '17.4',
  22: '16.6',
  21: '15.8',
  20: '15.1',
  19: '14.4',
  18: '13.7',
  17: '13',
  16: '12.4',
  15: '11.8',
  14: '11.2',
  13: '10.7',
  12: '10.2',
  11: '9.7',
  10: '9.2',
  9: '8.8',
  8: '8.3',
  7: '7.9',
  6: '7.5',
  5: '7.1',
  4: '6.8',
  3: '6.4',
  2: '6.1',
  1: '5.8',
  0: '5.5',
  '-1': '5.23',
  '-2': '4.96',
  '-3': '4.71',
  '-4': '4.46',
  '-5': '4.23',
  '-6': '4.01',
  '-7': '3.79',
  '-8': '3.59',
  '-9': '3.41',
  '-10': '3.23',
  '-11': '3.05',
  '-12': '2.89',
  '-13': '2.73',
  '-14': '2.58',
  '-15': '2.44',
  '-16': '2.31',
  '-17': '2.18',
  '-18': '2.06',
  '-19': '1.95',
  '-20': '1.83',
  '-21': '1.74',
  '-22': '1.63',
  '-23': '1.55',
  '-24': '1.45',
  '-25': '1.37',
  '-26': '1.29',
  '-27': '1.22',
  '-28': '1.15',
  '-29': '1.08',
  '-30': '1.02',
  '-31': '0.96',
  '-32': '0.91',
  '-33': '0.85',
  '-34': '0.8',
  '-35': '0.75',
  '-36': '0.71',
  '-37': '0.69',
  '-38': '0.63',
  '-39': '0.59',
  '-40': '0.55',
  '-41': '0.52',
  '-42': '0.49',
  '-43': '0.46',
  '-44': '0.43',
  '-45': '0.4',
  '-46': '0.38',
  '-47': '0.35',
  '-48': '0.33',
  '-49': '0.31',
  '-50': '0.29',
  '-51': '0.27',
  '-52': '0.25',
  '-53': '0.23',
  '-54': '0.22',
  '-55': '0.21',
  '-56': '0.19',
  '-57': '0.18',
  '-58': '0.17',
  '-59': '0.15',
  '-60': '0.14',
  '-61': '0.13',
  '-62': '0.13',
  '-63': '0.12',
  '-64': '0.11',
  '-65': '0.1',
  '-66': '0.09',
  '-67': '0.09',
  '-68': '0.08',
  '-69': '0.07',
  '-70': '0.07',
  '-71': '0.06',
  '-72': '0.06',
  '-73': '0.05',
  '-74': '0.05',
  '-75': '0.05',
  '-76': '0.04',
  '-77': '0.04',
  '-78': '0.04',
  '-79': '0.03',
  '-80': '0.03',
  '-81': '0.03',
  '-82': '0.03',
  '-83': '0.02',
  '-84': '0.02',
  '-85': '0.02',
  '-86': '0.02',
  '-87': '0.02',
  '-88': '0.02',
  '-89': '0.01',
  '-90': '0.01',
  '-91': '0.01',
  '-92': '0.01',
  '-93': '0.01',
  '-94': '0.01',
  '-95': '0.01',
  '-96': '0.01',
  '-97': '0.01',
  '-98': '0.01',
  '-99': '0.01',
  '-100': '0.01',
};

export function calculateDewPoint(relativeHumidity: number, temperatureFahrenheit: number) {
  const temperatureCelcius = (temperatureFahrenheit - 32) / 1.8;
  const dewPointCelcius =
    temperatureCelcius -
    (14.55 + 0.114 * temperatureCelcius) * (1 - 0.01 * relativeHumidity) -
    ((2.5 + 0.007 * temperatureCelcius) * (1 - 0.01 * relativeHumidity)) ** 3 -
    (15.9 + 0.117 * temperatureCelcius) * (1 - 0.01 * relativeHumidity) ** 14;
  const dewPointFahrenheit = dewPointCelcius * (9 / 5) + 32;
  return dewPointFahrenheit;
}

export function calculateGPP(dewPoint: number) {
  let dewPointForCalculation = Math.trunc(dewPoint);
  if (dewPointForCalculation > 100) {
    dewPointForCalculation = 100;
  } else if (dewPointForCalculation < -100) {
    dewPointForCalculation = -100;
  }
  return gppTable[dewPointForCalculation];
}

// todo: see if it's possible to remove the need for this
// there's already a similar whitelist filter in MoistureLogs.tsx that's used to filter out logs with non-dryable materials
export function dryableMaterialFilter(material: any) {
  const {
    damage_type: { name: damageTypeName, is_dryable: isTypeDryable },
    name: materialName,
    is_standard: isStandard,
  } = material;

  if (!isTypeDryable) {
    return false;
  }
  if (!isStandard) {
    return true;
  }
  switch (damageTypeName) {
    case 'Carpentry':
      return dryingWhitelists.carpentry.some((material) => material === materialName);
    case 'Ceiling':
      return dryingWhitelists.ceiling.some((material) => material === materialName);
    case 'Flooring':
      return dryingWhitelists.flooring.some((material) => material === materialName);
    case 'Plumbing':
      return dryingWhitelists.plumbing.some((material) => material === materialName);
    case 'Walls':
      return dryingWhitelists.walls.some((material) => material === materialName);
    default:
      return false;
  }
}
